const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        entry: 'Eintritt Station: {resname}',
        leave: 'Austritt Station: {resname}',
    },
    __RELATIVE_SOURCE_FILE__
);
